import {doc} from '../docs.js';
import {getLeafString, dash, dot} from 'effects/midi/tidal/parser.js';
import {
    applyToLeaf,
    applyRule,
    before,
    after,
    when ,
    otherwise,
    ACCENT,
    FLAM,
    STACCATO,
    DOUBLE,
    REST,
    LEGATO,
    PIANO,
    PIANISSIMO
} from 'effects/midi/scripting/trules.js';

// an object that spits out a simple rule
// similar to scripting where you write rules like
// when(ACCENT).always(LEGATO) 
doc(
    "jwhen",
    {
        predicate: "predicate",
        action: "action",
    },
    "When predicate is met do action",
    undefined,
    {
        isHot: true
    }
);

export const jwhen = (object, predicate, action) => {
    return () => {
        let _predicate = byName(predicate());
        let _action = byName(action());
        if (!_predicate || !_action) {
            return undefined;
        }
        return when(_predicate).always(_action);
    };
};

doc(
    "jbefore",
    {
        predicate: "predicate",
        action: "action",
    },
    "When predicate is met do action",
    undefined,
    {
        isHot: true
    }
);

export const jbefore = (object, predicate, action) => {
    return () => {
        let _predicate = byName(predicate());
        let _action = byName(action());
        if (!_predicate || !_action) {
            return undefined;
        }
        return before(_predicate).always(_action);
    };
};

doc(
    "jafter",
    {
        predicate: "predicate",
        action: "action",
    },
    "When predicate is met do action",
    undefined,
    {
        isHot: true
    }
);

export const jafter = (object, predicate, action) => {
    return () => {
        let _predicate = byName(predicate());
        let _action = byName(action());
        if (!_predicate || !_action) {
            return undefined;
        }
        return after(_predicate).always(_action);
    };
};

doc(
    "jotherwise",
    {
        action: "action",
    },
    "If no other predicates are met, do action",
    undefined,
    {
        isHot: true
    }
);

export const jotherwise = (object, action) => {
    return () => {
        let _action = byName(action());
        if (!_action) {
            return undefined;
        }
        return otherwise().always(_action);
    };
};


const byName = (name) => {
    switch (name) {
    case "accent":
        return ACCENT;
    case "legato":
        return LEGATO;
    case "piano":
        return PIANO;
    case "rest":
        return REST;
    case "staccato":
        return STACCATO;
    case ".":
        return dot();
    case "-":
        return dash(0);
    case "--":
        return dash(1);
    case "double":
        return DOUBLE;
    case "flam":
        return FLAM;
    case "after":
        return after;
    case "before":
        return before;
    }
};

export const jrules = {
    jwhen,
    jotherwise,
    jafter,
    jbefore
};
